import { render, staticRenderFns } from "./fillblankTopic.vue?vue&type=template&id=9f5af2ce&scoped=true"
import script from "./fillblankTopic.vue?vue&type=script&lang=js"
export * from "./fillblankTopic.vue?vue&type=script&lang=js"
import style0 from "./fillblankTopic.vue?vue&type=style&index=0&id=9f5af2ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5af2ce",
  null
  
)

export default component.exports